module.exports = __webpack_public_path__ + "static/media/tron_1.27f8693f.gif";